var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4246_18045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79591 13.6815L14.1891 6.6815C15.4176 5.51807 15.3228 3.45864 13.9788 2.1375C12.6679 0.848354 10.6679 0.759211 9.51019 1.93978L2.31934 9.28035C2.31934 9.28035 3.91248 9.9135 5.03248 11.0141C6.15248 12.1146 6.79591 13.6815 6.79591 13.6815Z",
    stroke: "#F48220",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74132 14.9864L6.79275 13.687C6.79275 13.687 6.14932 12.1201 5.03046 11.0184C3.91161 9.91668 2.31961 9.28125 2.31961 9.28125L0.991607 14.2298C0.876179 14.6618 1.30818 15.0984 1.74132 14.9864V14.9864Z",
    stroke: "#F48220",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4246_18045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.ee25e6457b12a01db5ac35d7700d1992.svg";
export { ForwardRef as ReactComponent };